import { useRef } from 'react'
import { Link } from 'react-router-dom'

import styles from './BillingRow.module.scss'

const amountInfoStyles = {
  none: styles.amountInfo,
  good: styles.amountInfoGood,
  badish: styles.amountInfoBadish,
  bad: styles.amountInfoBad
}

const BillingRow = ({
  pretitle,
  title,
  titleInfo,
  amount,
  amountInfo,
  amountStyle = 'none',
  manageLink,
  viewLink,
  isInternalAdmin,
  amountTip,
  hasHoverState = true,
  viewText = 'See details →'
}) => {
  const titleRef = useRef()
  const titleInfoRef = useRef()

  const titleTip = titleRef.current
    ? titleRef.current.scrollWidth > titleRef.current.clientWidth
      ? title
      : ''
    : ''

  const titleInfoTip = titleInfoRef.current
    ? titleInfoRef.current.scrollWidth > titleInfoRef.current.clientWidth
      ? titleInfo
      : ''
    : ''

  const className = [styles.rowBigger, hasHoverState ? styles.rowClickable : ''].join(' ')

  if (isInternalAdmin) {
    return (
      <div className={className}>
        <div className={styles.titleCol}>
          <div className={styles.title} ref={titleRef} data-tip={titleTip}>
            {title}
          </div>
          <div className={styles.titleInfo} data-tip={titleInfoTip} ref={titleInfoRef}>
            <span className={styles.titleInfoInner}>{titleInfo}</span>
          </div>
          <div className={styles.titleInfoHover}>
            <span className={styles.adminControls}>
              <Link to={viewLink}>
                <button>View</button>
              </Link>
              {manageLink && (
                <Link to={manageLink}>
                  <button>Manage</button>
                </Link>
              )}
            </span>
          </div>
        </div>
        <div className={styles.amountCol} data-tip={amountTip}>
          <div className={styles.amount}>{amount}</div>
          <div className={[amountInfoStyles[amountStyle]]}>{amountInfo}</div>
        </div>
      </div>
    )
  }

  return (
    <Link className={className} to={viewLink}>
      <div className={styles.titleCol}>
        <div className={styles.preTitle}>{pretitle}</div>
        <div className={styles.title} ref={titleRef} data-tip={titleTip}>
          {title}
        </div>
        <div className={styles.titleInfo} data-tip={titleInfoTip} ref={titleInfoRef}>
          <span className={styles.titleInfoInner}>{titleInfo}</span>
        </div>
        <div className={styles.titleInfoHover}>{viewText}</div>
      </div>
      <div className={styles.amountCol} data-tip={amountTip}>
        <div className={styles.amount}>{amount}</div>
        <div className={[amountInfoStyles[amountStyle]]}>{amountInfo}</div>
      </div>
    </Link>
  )
}

export default BillingRow
